import i18n from "lib/i18n";
import $ from "jquery";
import { template } from "lodash";
import { View } from "backbone";
/* eslint-disable
    consistent-return,
    func-names,
    no-multi-assign,
    no-shadow,
    no-undef,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
let CommentBodyView;
export default CommentBodyView = (function () {
  CommentBodyView = class CommentBodyView extends View {
    static initClass() {
      this.prototype.className = "comment-body-view";

      this.prototype.events =
        { "click .show-comment": "_showFullComment" };

      this.prototype.template = template(`\
<div class="comment-body-wrapper">
  <%= fullBody %>
</div>
<a class="show-comment" href="#"><%= i18n.t('comment.button.read_more') %></a>\
`, { imports: { i18n } });
    }

    initialize(options) {
      this.fullBody = options.fullBody;
      return this.render();
    }

    render() {
      this.el.innerHTML = this.template({ fullBody: this.fullBody });

      if (this.fullBody.length > 1000) {
        return $(this.el).addClass("truncated");
      }
    }

    _showFullComment(event) {
      event.preventDefault();

      $(this.el).removeClass("truncated");
      return $(this.el).find(".show-comment").remove();
    }
  };
  CommentBodyView.initClass();
  return CommentBodyView;
}());
